// GENERATED FILE - DO NOT MODIFY

export enum ArticleChannelDto {
    Batirente = "Batirente",
    Fondaction = "Fondaction",
    All = "All",
}